import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { storeUrlForMeetingAddress } from '../lib/meetingAddress';
import { usePortalSiteStore } from '../stores/portalSiteStore';

/**
 * PD-17809 — keeps a brand's meeting address to its booking pages by sending anything else
 * opened there to the store. Side-effect only (renders nothing), like BrandThemeApplier, and
 * a full navigation because the store is on a different host.
 */
export function MeetingAddressRedirect(): null {
	const { pathname, search } = useLocation();
	const meetingHostname = usePortalSiteStore((s) => s.site?.meetingHostname);
	const canonicalOrigin = usePortalSiteStore((s) => s.site?.canonicalOrigin);

	useEffect(() => {
		const storeUrl = storeUrlForMeetingAddress({
			hostname: window.location.hostname,
			pathname,
			search,
			meetingHostname,
			canonicalOrigin,
		});

		if (storeUrl != null) {
			window.location.replace(storeUrl);
		}
	}, [canonicalOrigin, meetingHostname, pathname, search]);

	return null;
}
